import { render, staticRenderFns } from "./SingleTableRow.vue?vue&type=template&id=496963dc&scoped=true&"
import script from "./SingleTableRow.vue?vue&type=script&lang=js&"
export * from "./SingleTableRow.vue?vue&type=script&lang=js&"
import style0 from "./SingleTableRow.vue?vue&type=style&index=0&id=496963dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496963dc",
  null
  
)

export default component.exports